/**
 * Zentrale Konstanten: Speicherschluessel und die aus dem Deployment
 * abgeleitete Redirect-URI.
 */

export const STORAGE_KEYS = {
  clientId: 'spotibox.clientId',
  tokens: 'spotibox.tokens',
  pkceVerifier: 'spotibox.pkce.verifier',
  pkceState: 'spotibox.pkce.state',
  settings: 'spotibox.settings',
} as const;

/**
 * Exakt dieser Wert muss im Spotify Developer Dashboard als Redirect-URI
 * eingetragen sein – inklusive abschliessendem Slash.
 *
 * Produktion: https://schdief.github.io/spotibox/
 * Entwicklung: http://127.0.0.1:5173/spotibox/
 */
export function getRedirectUri(): string {
  return `${window.location.origin}${import.meta.env.BASE_URL}`;
}

/** Basis-URL der App (z. B. "/spotibox/"), fuer Redirects nach dem Login. */
export function getAppUrl(): string {
  return getRedirectUri();
}
